import React from 'react';
import {IProps} from './types';
import * as S from './styles';
import { noSpecialCharacters, validateNumbers } from '@utils/userUtils';

const Input:React.FC<IProps> = (props) => {

  const validationFunction = 
    props.validationType === "validate-numbers" ? validateNumbers :
    props.validationType === "no-special-characters" ? noSpecialCharacters :
    undefined;

  return (
    <S.Root style={props.style} >
      <S.InputContainer 
        id={props.id}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.handleChange}
        onFocus={props.handleFocus}
        onBlur={props.handleBlur}
        disabled={props.disabled}
        style={props.inputStyle}
        onKeyDown={props.onKeyPress ?? validationFunction}
        onPaste={props.onPaste ?? validationFunction}
      />
      {
        props.tipLabel !== "" &&
        <S.TipLabel textColor={props.tipLabelColor} >
          {props.tipLabel}
        </S.TipLabel>
      }
    </S.Root>
  );
}

export default Input;